exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-busybee-busy-bee-tsx": () => import("./../../../src/pages/busybee/BusyBee.tsx" /* webpackChunkName: "component---src-pages-busybee-busy-bee-tsx" */),
  "component---src-pages-busybee-index-tsx": () => import("./../../../src/pages/busybee/index.tsx" /* webpackChunkName: "component---src-pages-busybee-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

